import { PieChart } from '@/common/dashboard/charts/PieChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

export const ChbkProgressChart = ({ selectedDistCusts = [], selectedPeriod }) => {

  const { navigateTo } = useNavState();

  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {

    if (!selectedPeriod?.id) {
      return null;
    }

    const distCustIds = selectedDistCusts.map(distCust => distCust.id);
    const reqParam = {
      periodId: selectedPeriod?.id,
      distCustIds
    };

    rsrc.data('sc', 'CHBK_PROGRESS_CHART_DATA_PLUGIN', reqParam).then(data => {
      setData(data);
    });
  }, [selectedDistCusts, selectedPeriod]);

const navigateToSaleList = (dataPoint) => {

    const indirSaleIds = dataPoint.indirSaleIds;
    let expr = ExprUtils.whereParams('id', indirSaleIds);
    
    const navState = {
      mode: Mode.LIST,
      expr: expr,
    };

    navigateTo('sc/indir-sale', navState);
};


  if (!data || data.length === 0) return;

  return (
    <PieChart
      data={data}
      onClick={(dataPoint) => navigateToSaleList(dataPoint)}
    />
  );
};
